/**
 * The terminal's error code in words a customer understands. Codes vary by
 * terminal and acquirer, so this matches on what the code says rather than an
 * exact list; anything unrecognised gets the general line. The raw code still
 * shows, small, for the cashier.
 */
export function paymentErrorText(code: string, t: (key: string) => string): string {
  const c = code.toUpperCase()
  // A wrong PIN or an expired card reads as declined, before LIMIT or EXPIRE
  // can call it a balance or a timeout.
  if (/PIN|CARD_?EXPIR|EXPIRED_?CARD/.test(c)) return t('payment-error-declined')
  if (/FUNDS|BALANCE|LIMIT/.test(c)) return t('payment-error-funds')
  if (/DECLIN|REFUS|DENI|REJECT|NOT_AUTH/.test(c)) return t('payment-error-declined')
  if (/CANCEL|ABORT/.test(c)) return t('payment-error-cancelled')
  if (/TIMEOUT|TIMED|EXPIRE/.test(c)) return t('payment-error-timeout')
  if (/NETWORK|CONNECT|OFFLINE|UNREACH/.test(c)) return t('payment-error-connection')
  return t('payment-error-sub')
}
